import * as React from "react"
import {Box} from "@mui/material";
import {ButtonLoadingSeeker, IconSeeker} from "@ui-seeker/core";

import {disabledSubmitNewProducts, isLoadingNewProducts} from "../@signals";


export default function NewProductsFiltersBlockFooter() {

	return <Box sx={{ display: 'flex', gap: 2 }}>
		<ButtonLoadingSeeker
			disabled={disabledSubmitNewProducts.value}
			loading={isLoadingNewProducts.value}
			onClick={() => {
				isLoadingNewProducts.value = true
			}}
			startIcon={<IconSeeker icon="filter" />}
		>
			Submit
		</ButtonLoadingSeeker>
	</Box>
}